import INVOICE_REQUEST from "./invoiceRequest.graphql";

const subscriptionService = ({ gqlClient }) => {
	const invoiceRequest = ({ invoiceItem, billingInfo }, turingToken) =>
		gqlClient(
			INVOICE_REQUEST,
			{ invoiceItem, billingInfo },
			{
				headers: {
					"x-turing-token": turingToken,
				},
			},
		);

	return {
		invoiceRequest,
	};
};

export default subscriptionService;
